<template>
  <div class="content" >
    <div class="section-header text-center" id="week">
      <h2 class="section-title wow fadeInDown" data-wow-delay="0.3s">برنامه هفتگی و امتحانات نیمسال اول 1403-1404</h2>
      <div class="shape wow fadeInDown" data-wow-delay="0.3s"></div>
    </div>
    <div class="row justify-content-center  " >
      <div class="col-8">
        <vueper-slides
            fade autoplay
            :touchable="false"
            :pause-on-hover="pauseOnHover"
            :dragging-distance="50"
            :slide-ratio="1 / 2"
        >
          <vueper-slide id="services"
              v-for="(slide, i) in slides"
              :key="i"
              :image="slide.image"
          />
        </vueper-slides>
      </div>
    </div>
    <hr>
  </div>
</template>
<script>
import { VueperSlides, VueperSlide } from 'vueperslides'
export default {
  name: "WeeklySchedule",
  components: { VueperSlides, VueperSlide },
  data(){
    return{
      // autoplay:false,
      pauseOnHover:true,
      slides: [
        {
          image: require('../assets/img/weeklySchedule/z11.gif')
        },
        {
          image: require('../assets/img/weeklySchedule/z12.gif')
        },
        {
          image: require('../assets/img/weeklySchedule/z13.gif')
        },
        {
          image: require('../assets/img/weeklySchedule/z14.gif')
        },
        {
          image: require('../assets/img/weeklySchedule/z15.gif')
        },
        {
          image: require('../assets/img/weeklySchedule/z16.gif')
        },
        {
          image: require('../assets/img/weeklySchedule/z17.gif')
        },


      ]
    }
  }
}
</script>
<style scoped>
</style>